import React, { useState } from 'react';
import { X, Check } from 'lucide-react';
import { ACTIVITY_META } from '../utils/redemption';

// Manual "log your redemption" — the everywhere-fallback for the Rap Sheet.
// Type what your run app said; we never track the workout ourselves.
const TYPES = ['run', 'ride', 'walk', 'hike', 'swim', 'strength', 'hiit', 'yoga'];
const DISTANCE_TYPES = ['run', 'ride', 'walk', 'hike', 'swim'];

const LogWorkoutModal = ({ drinks, onSubmit, onClose }) => {
  const [type, setType] = useState('run');
  const [km, setKm] = useState('');
  const [min, setMin] = useState('');
  const needsDistance = DISTANCE_TYPES.includes(type);
  const valid = needsDistance ? Number(km) > 0 : Number(min) > 0;

  const submit = (e) => {
    e.preventDefault();
    if (!valid) return;
    onSubmit({ type, distanceKm: Number(km) || 0, durationMin: Number(min) || 0 });
  };

  return (
    <div className="absolute inset-0 z-[3500] bg-black/90 flex items-end sm:items-center justify-center p-4 animate-in fade-in duration-200" onClick={onClose}>
      <form onSubmit={submit} onClick={(e) => e.stopPropagation()}
        className="w-full max-w-sm bg-zinc-900 border border-white/10 rounded-3xl p-6 shadow-2xl relative">
        <button type="button" onClick={onClose} className="absolute top-4 right-4 text-zinc-500 hover:text-white"><X size={20} /></button>

        <h2 className="text-lg font-black italic uppercase tracking-tight text-white">Log your payback</h2>
        <p className="text-[11px] font-bold text-zinc-400 mt-1 mb-5 leading-relaxed">
          {drinks || 0} drinks on the books. What did you do about it this morning? Copy it from Strava, Garmin, Apple Fitness — wherever you logged it.
        </p>

        <label className="text-[10px] font-black text-zinc-500 uppercase tracking-widest mb-2 block">Activity</label>
        <div className="grid grid-cols-4 gap-2 mb-5">
          {TYPES.map(t => (
            <button key={t} type="button" onClick={() => setType(t)}
              className={`flex flex-col items-center gap-1 py-2.5 rounded-xl border text-[9px] font-black uppercase tracking-widest transition-colors ${type === t ? 'bg-brand-teal text-black border-brand-teal' : 'bg-black text-zinc-400 border-zinc-700'}`}>
              <span className="text-lg leading-none">{ACTIVITY_META[t].emoji}</span>{ACTIVITY_META[t].label}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-2 gap-3 mb-5">
          <div>
            <label className="text-[10px] font-black text-zinc-500 uppercase tracking-widest mb-1 block">
              Distance (km){!needsDistance && <span className="text-zinc-700"> · optional</span>}
            </label>
            <input type="number" inputMode="decimal" step="0.01" min="0" placeholder="8.04" value={km} onChange={e => setKm(e.target.value)}
              className="w-full bg-black border border-zinc-700 rounded-xl p-3 text-lg font-black text-white focus:outline-none focus:border-brand-teal" />
          </div>
          <div>
            <label className="text-[10px] font-black text-zinc-500 uppercase tracking-widest mb-1 block">
              Minutes{needsDistance && <span className="text-zinc-700"> · for pace</span>}
            </label>
            <input type="number" inputMode="decimal" step="1" min="0" placeholder="46" value={min} onChange={e => setMin(e.target.value)}
              className="w-full bg-black border border-zinc-700 rounded-xl p-3 text-lg font-black text-white focus:outline-none focus:border-brand-teal" />
          </div>
        </div>

        <button type="submit" disabled={!valid}
          className="w-full bg-brand-pink text-white font-black py-4 rounded-xl uppercase tracking-widest active:scale-95 transition-transform flex items-center justify-center gap-2 disabled:opacity-30 disabled:cursor-not-allowed">
          <Check size={18} /> Stamp the Rap Sheet
        </button>
      </form>
    </div>
  );
};

export default LogWorkoutModal;
